// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4143":"2efc7ca4ca0cd784","9270":"35185d4ec2cfb976"}[chunkId] + ".css";
};